<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
  >
    <p> Você tem certeza que deseja deletar a parcela ?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
 data () {
  return {
    error: null,
    loading: true,
    formErrors: []
  }
},
components: {
  BaseDelete: BaseDelete
},
props: {
  entry: Object,
  modelNameSingular: String,
},
 methods: {
   destroyServerEntry: function(installment) {
     this.loading = true;
      this.$apollo
        .mutate({
          mutation: DESTROY_INSTALLMENT_MUTATION,
          variables: {
            id: installment.id,
          }
        })
        .then(response => {
          var errors = response.data.destroyUnpaidInstallment.errors;
          if (errors.length){
            this.formErrors = errors
          } else {
            this.$emit("entry-destroyed");
          }
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
   },
   destroyEntry: function() {
     this.destroyServerEntry(this.entry);
   },
 }
}
const DESTROY_INSTALLMENT_MUTATION = gql `
  mutation($id: ID!) {
    destroyUnpaidInstallment(id: $id) {
      installment {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>